export enum SeasonEntityRosterStatuses {
  Approved = "APPROVED",
  Pending = "PENDING",
  Rejected = "REJECTED",
  Submitted = "SUBMITTED",
  Unknown = "UNKNOWN",
}
